var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8 16C28.8 23.0693 23.0692 28.8 16 28.8C8.93075 28.8 3.2 23.0693 3.2 16C3.2 8.93077 8.93075 3.20001 16 3.20001C23.0692 3.20001 28.8 8.93077 28.8 16ZM13.6 14.4C12.7163 14.4 12 15.1164 12 16C12 16.8837 12.7163 17.6 13.6 17.6H14.4V22.3992V22.4C14.4 23.2837 15.1163 24 16 24H18.4C19.2837 24 20 23.2837 20 22.4C20 21.5164 19.2837 20.8 18.4 20.8H17.6V16.0039L17.6 16C17.6 15.1164 16.8837 14.4 16 14.4H13.6ZM16 8.40001C14.8954 8.40001 14 9.29544 14 10.4C14 11.5046 14.8954 12.4 16 12.4H16.016C17.1206 12.4 18.016 11.5046 18.016 10.4C18.016 9.29544 17.1206 8.40001 16.016 8.40001H16Z",
    fill: "#58A9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.fe5845a5dc0819a13806dc011371d15b.svg";
export { ForwardRef as ReactComponent };